var showAllLoadCases = true;
// use this variable as a function holder to know which dialog is
// open (and which to configure) when the "show all loads" check box
// is toggled.
var currentLoadDialogToToggle = toggleUniformLoadMagnitudeDisplay;

function openModalLoadDialog() {
    $('#modal-load-dialog').modal('show');
}

function onLeftEndClick() {
    document.getElementById('starting-at-input').value = showLengthWithUnits(0)
    document.getElementById('point-load-location-input').value = showLengthWithUnits(0)
}

function onRightEndClick() {
    document.getElementById('ending-at-input').value = showLengthWithUnits(0)
    document.getElementById('point-load-location-input').value = showLengthWithUnits(0)
}
    
function onLoadStartingInputChange() {
    return (validateRequiredInput('starting-at-input') && 
    validateLengthInput('starting-at-input') &&
    validateLocation('starting-at-input') && 
    validateDistributedLoadPosition('starting-at-input', 'ending-at-input')) 
}

function onLoadEndingInputChange() {
    return (validateRequiredInput('ending-at-input') && 
    validateLengthInput('ending-at-input') &&
    validateLocation('ending-at-input') && 
    validateDistributedLoadPosition('starting-at-input', 'ending-at-input')) 
}

function onPointLoadLocationChange() {
    return (validateRequiredInput('point-load-location-input') &&
    validateLengthInput('point-load-location-input') &&
    validateLocation('point-load-location-input'))
}

function onSelfWeightClicked() {
    activeProject.design.includeSelfWeight = $('#self-weight-checkbox').is(':checked');
}

function removeLoadDialogClickHandlers() {
    document.getElementById('save-load-button').onclick = function(){ return false }
    document.getElementById('delete-load-button').onclick = function(){ return false }
}

/// TODO: don't cause redraw (from triggering load precision changed)
// we're doing way too many redraws at the moment...
function configureLoadPrecision(decimalPlaces) {
  document.getElementById("load-precision-dropdown").innerHTML = "Load Precision: " + decimalPlaces + " decimal places";
  activeProject.design.loadPrecision = parseInt(decimalPlaces);
  forcePrecisionDecimalPlaces = decimalPlaces;
  momentPrecisionDecimalPlaces = decimalPlaces;
  updateLoadTable();
  autoBeamFlexureDesign();
}

function onLoadPrecisionClick(decimalPlaces) {
    if(customerGate()) { 
        $('#modal-load-dialog').modal('hide');
        return; 
    }
    configureLoadPrecision(decimalPlaces);
    RedrawCanvas();
}

function initLoadTable() {

    // trigger load-precision-changed (causes redraw) and calls updateLoadTable
    configureLoadPrecision(activeProject.loadPrecision);

    $('#modal-load-editor-dialog').on('hidden.bs.modal', function () {
        removeLoadDialogClickHandlers()
    });

    document.getElementById('show-all-load-cases-1').onchange = function() {
        showAllLoadCases = document.getElementById('show-all-load-cases-1').checked
        document.getElementById('show-all-load-cases-2').checked = showAllLoadCases
        updateLoadTable();
        currentLoadDialogToToggle();
    }

    document.getElementById('show-all-load-cases-2').onchange = function() {
        showAllLoadCases = document.getElementById('show-all-load-cases-2').checked
        document.getElementById('show-all-load-cases-1').checked = showAllLoadCases
        updateLoadTable();
        currentLoadDialogToToggle();
    }
    
    // already called above?
    updateLoadTable();

}

function makeDistributedLoadCell(load1, load2, isLinear) {
    return isLinear ? `<td><p>${showBigLinearForce(load1)}<p>${showBigLinearForce(load2)}</td>` : `<td>${showBigLinearForce(load1)}</td>`
}

function updateLoadTable() {
    var str = "<table class='table table-hover' id='load-selector-table'><thead><tr class='success'>";
    str += "<th style='width:50px;'>ID</th><th style='width:50px;'>Type</th>";
    str += "<th style='width:200px;'>Location</th>";
    if (showAllLoadCases) {
        str += "<th>D</th><th>L</th><th>Lr</th><th>S</th><th>W</th><th>E</th><th>H</th><th>R</th>";
    } else {
        str += "<th>Magnitude</th>";
    }
    str += "</tr></thead>";
    var load_num = 0;
    for( var i = 0; i < activeProject.beam.distLoads.length; i++ ) {
        var load = activeProject.beam.distLoads[i];
        load_num += 1;
        var load_type = load.isLinear ? "Linear" : "Uniform", load_id = load.isLinear ? 'wsLinearLoad_' + i : 'wsUniformLoad_' + i;
        str += "<tr class='" + load_id + "'>";
        str += "<td style='width:50px;' >"+ load_num + "</td>";
        str += "<td>"+ load_type + "</td>";
        str += "<td>"+ showLengthWithUnits(load.x1) + " &nbsp; to &nbsp; " + showLengthWithUnits(load.x2) + "</td>";
        str += makeDistributedLoadCell(load['D'], load['D2'], load.isLinear);
        if (showAllLoadCases) {
            str += makeDistributedLoadCell(load['L'], load['L2'], load.isLinear);
            str += makeDistributedLoadCell(load['Lr'], load['Lr2'], load.isLinear);
            str += makeDistributedLoadCell(load['S'], load['S2'], load.isLinear);
            str += makeDistributedLoadCell(load['W'], load['W2'], load.isLinear);
            str += makeDistributedLoadCell(load['E'], load['E2'], load.isLinear);
            str += makeDistributedLoadCell(load['H'], load['H2'], load.isLinear);
            str += makeDistributedLoadCell(load['R'], load['R2'], load.isLinear);
        }
        str += "</tr>";
    }
    for( var i = 0; i < activeProject.beam.pointLoads.length; i++ ) {
        var load = activeProject.beam.pointLoads[i];
        load_num += 1;
        var load_type = load.isMoment ? "Moment" : "Point", load_id = load.isLinear ? 'wsPointLoad_' + i : 'wsMoment_' + i;
        var show_func = showBigPointLoad;
        if(load.isMoment) {
            show_func = showBigMoment;
        }
        str += "<tr class='wsPointLoad_" + i + "'>";
        str += "<td style='width:50px;'>"+ load_num + "</td>";
        str += "<td>"+ load_type + "</td>";
        str += "<td>"+ showLengthWithUnits(load.x) + "</td>";
        str += "<td>"+ show_func(load["D"]) + "</td>";
        if (showAllLoadCases) {
            str += "<td>"+ show_func(load["L"]) + "</td>";
            str += "<td>"+ show_func(load["Lr"]) + "</td>";
            str += "<td>"+ show_func(load["S"]) + "</td>";
            str += "<td>"+ show_func(load["W"]) + "</td>";
            str += "<td>"+ show_func(load["E"]) + "</td>";
            str += "<td>"+ show_func(load["H"]) + "</td>";
            str += "<td>"+ show_func(load["R"]) + "</td>";
        }
        str += "</tr>";
    }
    str += "</table>";

    document.getElementById('load-panel').innerHTML = str

    const table = document.getElementById('load-selector-table')
    for (let i = 0, row; row = table.rows[i]; i++) {
        if(row.classList.length <= 0 || !row.classList[0].match(/ws/)) {
            continue
        }
        const myClass = row.classList[0]
        if (myClass.match(/wsUniformLoad/) && myClass.match(/wsUniformLoad/).length > 0) {
            row.onclick = () => openUniformLoadDialog(parseInt(myClass.split(/wsUniformLoad_/)[1]));
        } else if (myClass.match(/wsLinearLoad/) && myClass.match(/wsLinearLoad/).length > 0) {
            row.onclick = () => openLinearLoadDialog(parseInt(myClass.split(/wsLinearLoad_/)[1]));
        } else if (myClass.match(/wsPointLoad/) && myClass.match(/wsPointLoad/).length > 0) {
            row.onclick = () => openPointLoadDialog(parseInt(myClass.split(/wsPointLoad_/)[1]));
        } else if (myClass.match(/wsMoment/) && myClass.match(/wsMoment/).length > 0) {
            row.onclick = () => openMomentDialog(parseInt(myClass.split(/wsMoment_/)[1]));
        }
    }
}

/*********************************************
 * Uniform Loads
 ********************************************/
function toggleUniformLoadMagnitudeDisplay() {
    if (showAllLoadCases) {
        document.getElementById('load-magnitude-table').classList.remove('d-none')
        document.getElementById('w2-magnitude-row').classList.add('d-none')
        document.getElementById('distributed-load-magnitude-2').classList.add('d-none')
        document.getElementById('d-load-input-0').classList.add('d-none')
    } else {
        document.getElementById('load-magnitude-table').classList.add('d-none')
        document.getElementById('w2-magnitude-row').classList.add('d-none')
        document.getElementById('distributed-load-magnitude-2').classList.add('d-none')
        document.getElementById('d-load-input-0').classList.remove('d-none')
    }
    document.getElementById('distributed-load-location-table').classList.remove('d-none')
    document.getElementById('point-load-location-table').classList.add('d-none')
    if(gUnits === ENGLISH_UNITS) {
        $('.load-units-label').html('kips/ft');
    } else {
        $('.load-units-label').html('kN/m');
    }
}

function openUniformLoadDialog(loadIndex) {
    const displayIndex = loadIndex !== undefined ? parseInt(loadIndex) + 1 : undefined
    const title = loadIndex !== undefined ? `Edit Uniform Load ${displayIndex}` : 'Create New Uniform Load'
    
    // clear errors 
    const errorDiv = document.getElementById('ending-at-input-error')
    if(errorDiv) {  errorDiv.remove() }

    document.getElementById('modal-load-editor-dialog-label').innerHTML = title
    currentLoadDialogToToggle = toggleUniformLoadMagnitudeDisplay;
    removeLoadDialogClickHandlers()

    if (typeof loadIndex !== 'undefined' && loadIndex !== null) {
        document.getElementById('delete-load-button').classList.remove('d-none')
        document.getElementById('delete-load-button').onclick = function(e) { removeDistLoad(loadIndex) }
        setDistributedLoadInput(loadIndex);
    } else {
        document.getElementById('delete-load-button').classList.add('d-none')
        document.getElementById('starting-at-input').value = showLengthWithUnits(0)
        document.getElementById('ending-at-input').value = showLengthWithUnits(activeProject.beam.TotalLength())
    }
    document.getElementById('save-load-button').onclick = function(e) { saveUniformLoad(loadIndex) } 
    toggleUniformLoadMagnitudeDisplay()
    $('#modal-load-editor-dialog').modal('show');
    
}

function saveUniformLoad(loadIndex) {
    if(onLoadStartingInputChange() && onLoadEndingInputChange()) {
        removeLoadDialogClickHandlers()
        $('#modal-load-editor-dialog').modal('hide');
        if (typeof loadIndex !== 'undefined' && loadIndex !== null) {
            updateExistingDistributedLoad(loadIndex, false)
        } else {
            createNewDistributedLoad(false);
        }
        updateLoadTable()
        document.dispatchEvent(new CustomEvent('load-added-or-updated'))
    } 
}

function createNewDistributedLoad(isLinearLoad) {
    const args = getDistributedLoadInput(isLinearLoad)
    args.unshift(activeProject)
    LoadManager.addDistLoad(...args)
}

function updateExistingDistributedLoad(index, isLinearLoad) {
    if(onLoadStartingInputChange() && onLoadEndingInputChange()) {
        const args = getDistributedLoadInput(isLinearLoad)
        args.unshift(activeProject, index)
        LoadManager.modifyDistLoad(...args)
    }
}

function removeDistLoad(index) {
    removeLoadDialogClickHandlers()
    LoadManager.removeDistLoad(activeProject, index)
    $('#modal-load-editor-dialog').modal('hide');
    document.dispatchEvent(new CustomEvent('load-added-or-updated'))
}

/*********************************************
 * Linear Loads
 ********************************************/
function toggleLinearLoadMagnitudeDisplay() {
    console.log('toggle linear load magnitude display')
    if (showAllLoadCases) {
        document.getElementById('load-magnitude-table').classList.remove('d-none')
        document.getElementById('w2-magnitude-row').classList.remove('d-none')
        document.getElementById('distributed-load-magnitude-2').classList.add('d-none')
        document.getElementById('d-load-input-0').classList.add('d-none')
    } else {
        document.getElementById('load-magnitude-table').classList.add('d-none')
        document.getElementById('w2-magnitude-row').classList.add('d-none')
        document.getElementById('distributed-load-magnitude-2').classList.remove('d-none')
        document.getElementById('d-load-input-0').classList.remove('d-none')
    }
    document.getElementById('distributed-load-location-table').classList.remove('d-none')
    document.getElementById('point-load-location-table').classList.add('d-none')
    if(gUnits === ENGLISH_UNITS) {
        $('.load-units-label').html('kips/ft');
    } else {
        $('.load-units-label').html('kN/m');
    }
}

function openLinearLoadDialog(loadIndex) {
    const displayIndex = loadIndex !== undefined ? parseInt(loadIndex) + 1 : undefined
    const title = loadIndex !== undefined ? 'Edit Linear Load ' + displayIndex : 'Create New Linear Load';
    
    document.getElementById('modal-load-editor-dialog-label').innerHTML = title
    currentLoadDialogToToggle = toggleLinearLoadMagnitudeDisplay
    removeLoadDialogClickHandlers()
    
    if (typeof loadIndex !== 'undefined' && loadIndex !== null) {
        document.getElementById('delete-load-button').classList.remove('d-none')
        document.getElementById('delete-load-button').onclick = function(e) { removeDistLoad(loadIndex) }
        setDistributedLoadInput(loadIndex);
    } else {
        document.getElementById('delete-load-button').classList.add('d-none')
        document.getElementById('starting-at-input').value = showLengthWithUnits(0)
        document.getElementById('ending-at-input').value = showLengthWithUnits(activeProject.beam.TotalLength())
    }
    document.getElementById('save-load-button').onclick = function(e) { saveLinearLoad(loadIndex) } 
    toggleLinearLoadMagnitudeDisplay()
    $('#modal-load-editor-dialog').modal('show');
}

function saveLinearLoad(loadIndex) {
    if(onLoadStartingInputChange() && onLoadEndingInputChange()) {
        removeLoadDialogClickHandlers()
        $('#modal-load-editor-dialog').modal('hide');
        if (typeof loadIndex !== 'undefined' && loadIndex !== null) {
            updateExistingDistributedLoad(loadIndex, true)
        } else {
            createNewDistributedLoad(true);
        }
        updateLoadTable();
        document.dispatchEvent(new CustomEvent('load-added-or-updated'))
    }
}

/*********************************************
 * Point Loads
 ********************************************/

function togglePointLoadMagnitudeDisplay() {
    if (showAllLoadCases) {
        document.getElementById('load-magnitude-table').classList.remove('d-none')
        document.getElementById('w2-magnitude-row').classList.add('d-none')
        document.getElementById('distributed-load-magnitude-2').classList.add('d-none')
        document.getElementById('d-load-input-0').classList.add('d-none')
    } else {
        document.getElementById('load-magnitude-table').classList.add('d-none')
        document.getElementById('w2-magnitude-row').classList.add('d-none')
        document.getElementById('distributed-load-magnitude-2').classList.add('d-none')
        document.getElementById('d-load-input-0').classList.remove('d-none')
    }
    document.getElementById('distributed-load-location-table').classList.add('d-none')
    document.getElementById('point-load-location-table').classList.remove('d-none')
    if(gUnits === ENGLISH_UNITS) {
        $('.load-units-label').html('kips');
    } else {
        $('.load-units-label').html('kN');
    }
}


function openPointLoadDialog(loadIndex) {
    const displayIndex = loadIndex !== undefined ? parseInt(loadIndex) + 1 : undefined
    const title = loadIndex !== undefined ? 'Edit Point Load ' + displayIndex : 'Create New Point Load';

    document.getElementById('modal-load-editor-dialog-label').innerHTML = title
    currentLoadDialogToToggle = togglePointLoadMagnitudeDisplay;
    removeLoadDialogClickHandlers()
    
    if (typeof loadIndex !== 'undefined' && loadIndex !== null) {
        document.getElementById('delete-load-button').classList.remove('d-none')
        document.getElementById('delete-load-button').onclick = function(e) { removePointLoad(loadIndex) } 
        setPointLoadInput(loadIndex, false)
    } else {
        document.getElementById('delete-load-button').classList.add('d-none')
        document.getElementById('point-load-location-input').value = showLengthWithUnits(activeProject.beam.TotalLength() * 0.5)
    }
    document.getElementById('save-load-button').onclick = function(e) { savePointLoad(loadIndex) } 
    togglePointLoadMagnitudeDisplay()
    $('#modal-load-editor-dialog').modal('show');
    $('#point-load-label').html('Point');
}

function savePointLoad(loadIndex) {
    if(validateLocation('point-load-location-input')) {
        document.getElementById('save-load-button').removeAttribute('onclick')
        document.getElementById('delete-load-button').removeAttribute('onclick')
        $('#modal-load-editor-dialog').modal('hide');
        if (typeof loadIndex !== 'undefined' && loadIndex !== null) {
            updateExistingPointLoad(loadIndex, false)
        } else {
            createNewPointLoad(false);
        }
        updateLoadTable();
        document.dispatchEvent(new CustomEvent('load-added-or-updated'))
    }
}

function createNewPointLoad(isMoment) {
    const args = getPointLoadInput(isMoment)
    args.unshift(activeProject)
    LoadManager.addPointLoad(...args)
}

function updateExistingPointLoad(index, isMoment) {
    if(validateLocation('point-load-location-input')) {
        const args = getPointLoadInput(isMoment)
        args.unshift(activeProject, index)
        LoadManager.modifyPointLoad(...args)
    }
}

function removePointLoad(index) {
    document.getElementById('save-load-button').removeAttribute('onclick')
    document.getElementById('delete-load-button').removeAttribute('onclick')
    if(LoadManager.removePointLoad(activeProject, index)) {
        $('#modal-load-editor-dialog').modal('hide');
        document.dispatchEvent(new CustomEvent('load-added-or-updated'))
    }
}

/*********************************************
 * Moment Loads
 ********************************************/

function toggleMomentLoadMagnitudeDisplay() {
    if (showAllLoadCases) {
        document.getElementById('load-magnitude-table').classList.remove('d-none')
        document.getElementById('w2-magnitude-row').classList.add('d-none')
        document.getElementById('distributed-load-magnitude-2').classList.add('d-none')
        document.getElementById('d-load-input-0').classList.add('d-none')
    } else {
        document.getElementById('load-magnitude-table').classList.add('d-none')
        document.getElementById('w2-magnitude-row').classList.add('d-none')
        document.getElementById('distributed-load-magnitude-2').classList.add('d-none')
        document.getElementById('d-load-input-0').classList.remove('d-none')
    }
    document.getElementById('distributed-load-location-table').classList.add('d-none')
    document.getElementById('point-load-location-table').classList.remove('d-none')
    if(gUnits === ENGLISH_UNITS) {
        $('.load-units-label').html('kips-ft');
    } else {
        $('.load-units-label').html('kN-m');
    }
}


function openMomentDialog(loadIndex) {

    const displayIndex = loadIndex !== undefined ? parseInt(loadIndex) + 1 : undefined
    const title = loadIndex !== undefined ? 'Edit Point Load ' + displayIndex : 'Create New Point Load';

    document.getElementById('modal-load-editor-dialog-label').innerHTML = title
    currentLoadDialogToToggle = toggleMomentLoadMagnitudeDisplay
    removeLoadDialogClickHandlers()
    
    if (typeof loadIndex !== 'undefined' && loadIndex !== null) {
        document.getElementById('delete-load-button').classList.remove('d-none')
        document.getElementById('delete-load-button').onclick = function(e) { removePointLoad(loadIndex) } 
        setPointLoadInput(loadIndex, true)
    } else {
        document.getElementById('delete-load-button').classList.add('d-none')
        document.getElementById('point-load-location-input').value = showLengthWithUnits(activeProject.beam.TotalLength() * 0.5)
    }
    document.getElementById('save-load-button').onclick = function(e) { saveMomentLoad(loadIndex) } 
    toggleMomentLoadMagnitudeDisplay()
    $('#modal-load-editor-dialog').modal('show');
    $('#point-load-label').html('Moment');
}

function saveMomentLoad(loadIndex) {
    if(validateLocation('point-load-location-input')) {
        document.getElementById('save-load-button').removeAttribute('onclick')
        document.getElementById('delete-load-button').removeAttribute('onclick')
        $('#modal-load-editor-dialog').modal('hide');
        if (typeof loadIndex !== 'undefined' && loadIndex !== null) {
            updateExistingPointLoad(loadIndex, true)
        } else {
            createNewPointLoad(true);
        }
        document.dispatchEvent(new CustomEvent('load-added-or-updated'))
    }
}

/*********************************************
 * UI Get / Set
 ********************************************/
function setDistributedLoadInput(index) {
    if( index < 0 || index >= activeProject.beam.distLoads.length ) return alert( "Dist. load not found!");
    $("#starting-at-input").val(showLengthWithUnits(activeProject.beam.distLoads[index].x1));
    $("#ending-at-input").val(showLengthWithUnits(activeProject.beam.distLoads[index].x2));
    // NOTE: internal force unit in lbs
    $("#d-load-input").val(showBigLinearForce(activeProject.beam.distLoads[index].D));
    $("#d-load-input-0").val(showBigLinearForce(activeProject.beam.distLoads[index].D));
    $("#l-load-input").val(showBigLinearForce(activeProject.beam.distLoads[index].L));
    $("#lr-load-input").val(showBigLinearForce(activeProject.beam.distLoads[index].Lr));
    $("#s-load-input").val(showBigLinearForce(activeProject.beam.distLoads[index].S));
    $("#w-load-input").val(showBigLinearForce(activeProject.beam.distLoads[index].W));
    $("#e-load-input").val(showBigLinearForce(activeProject.beam.distLoads[index].E));
    $("#h-load-input").val(showBigLinearForce(activeProject.beam.distLoads[index].H));
    $("#r-load-input").val(showBigLinearForce(activeProject.beam.distLoads[index].R));
    $("#d-load-input-2").val(showBigLinearForce(activeProject.beam.distLoads[index].D2));
    $("#d-load-input-02").val(showBigLinearForce(activeProject.beam.distLoads[index].D2));
    $("#l-load-input-2").val(showBigLinearForce(activeProject.beam.distLoads[index].L2));
    $("#lr-load-input-2").val(showBigLinearForce(activeProject.beam.distLoads[index].Lr2));
    $("#s-load-input-2").val(showBigLinearForce(activeProject.beam.distLoads[index].S2));
    $("#w-load-input-2").val(showBigLinearForce(activeProject.beam.distLoads[index].W2));
    $("#e-load-input-2").val(showBigLinearForce(activeProject.beam.distLoads[index].E2));
    $("#h-load-input-2").val(showBigLinearForce(activeProject.beam.distLoads[index].H2));
    $("#r-load-input-2").val(showBigLinearForce(activeProject.beam.distLoads[index].R2));
}

function setPointLoadInput(index, isMoment) {
    //var show = isMoment ? showKipFt : showKips;
    var show = isMoment ? showBigMoment : showBigPointLoad;
    if(index < 0 || index >= activeProject.beam.pointLoads.length) return alert( "Load not found!");
    $("#point-load-location-input").val(showLengthWithUnits(activeProject.beam.pointLoads[index].x));
    // NOTE: internal force unit in lbs
    $("#d-load-input").val(show(activeProject.beam.pointLoads[index].D));
    $("#d-load-input-0").val(show(activeProject.beam.pointLoads[index].D));
    $("#l-load-input").val(show(activeProject.beam.pointLoads[index].L));
    $("#lr-load-input").val(show(activeProject.beam.pointLoads[index].Lr));
    $("#s-load-input").val(show(activeProject.beam.pointLoads[index].S));
    $("#w-load-input").val(show(activeProject.beam.pointLoads[index].W));
    $("#e-load-input").val(show(activeProject.beam.pointLoads[index].E));
    $("#h-load-input").val(show(activeProject.beam.pointLoads[index].H));
    $("#r-load-input").val(show(activeProject.beam.pointLoads[index].R));
}

function getDistributedLoadInput(isLinearLoad) {
    let d1 = "#d-load-input-0"
    let d2 = "#d-load-input-02"
    if (showAllLoadCases === true) {
        d1 = "#d-load-input";
        d2 = "#d-load-input-2";
    }
    var defaultUnit = "kips/ft";
    if(gUnits === METRIC_UNITS) {
        defaultUnit = "kN/m";
    }

    function parse(val, units) {
        return wsParseForcePerLength(Number(val).toString(), units);
    }

    return [
        wsParseLength($("#starting-at-input").val()),
        wsParseLength($("#ending-at-input").val()),
        parse($(d1).val(), defaultUnit),
        parse($("#l-load-input").val(), defaultUnit),
        parse($("#lr-load-input").val(), defaultUnit),
        parse($("#s-load-input").val(), defaultUnit),
        parse($("#w-load-input").val(), defaultUnit),
        parse($("#e-load-input").val(), defaultUnit),
        parse($("#h-load-input").val(), defaultUnit),
        parse($("#r-load-input").val(), defaultUnit),
        parse($(d2).val(), defaultUnit),
        parse($("#l-load-input-2").val(), defaultUnit),
        parse($("#lr-load-input-2").val(), defaultUnit),
        parse($("#s-load-input-2").val(), defaultUnit),
        parse($("#w-load-input-2").val(), defaultUnit),
        parse($("#e-load-input-2").val(), defaultUnit),
        parse($("#h-load-input-2").val(), defaultUnit),
        parse($("#r-load-input-2").val(), defaultUnit),
        isLinearLoad];
}

function getPointLoadInput(isMoment) {
    var units = isMoment ? "k-ft" : "kips";
    if(gUnits === METRIC_UNITS) {
        units = isMoment ? "kN-m" : "kN";
    }
    var d = showAllLoadCases ? "#d-load-input" : "#d-load-input-0";
    function parse(val, units) {
        return isMoment ? wsParseMoment(Number(val).toString(), units) : wsParseForce(Number(val).toString(), units);
    }
    return [
        wsParseLength($("#point-load-location-input").val()),
        parse($(d).val(), units),
        parse($("#l-load-input").val(), units),
        parse($("#lr-load-input").val(), units),
        parse($("#s-load-input").val(), units),
        parse($("#w-load-input").val(), units),
        parse($("#e-load-input").val(), units),
        parse($("#h-load-input").val(), units),
        parse($("#r-load-input").val(), units),
        isMoment];
}
